import { ArrowRight, Star } from "lucide-react";
import { GOOGLE_REVIEWS_URL, MARQUEE_ITEMS, PATIENT_QUOTES } from "./data";

export function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="marquee" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track">
        {items.map((item, i) => <span key={i}>{item}<i>✦</i></span>)}
      </div>
    </div>
  );
}

export function PatientTicker() {
  const items = [...PATIENT_QUOTES, ...PATIENT_QUOTES];
  return (
    <div className="patient-ticker-wrap">
      <div className="marquee patient-marquee" data-testid="patient-ticker">
        <div className="marquee-track">
          {items.map(([quote, who], i) => (
            <span className="marquee-item patient-quote" key={i}>
              <Star size={12} fill="currentColor" /> {quote} <b>— {who}</b>
            </span>
          ))}
        </div>
      </div>
      <div className="ticker-cta"><a className="google-reviews-pill" data-testid="google-reviews-link" href={GOOGLE_REVIEWS_URL} target="_blank" rel="noreferrer"><span className="g-stars">★★★★★</span><span>Rated by patients on Google — read all reviews</span><ArrowRight size={14} /></a></div>
    </div>
  );
}
